import React, { useEffect } from 'react';
import PartnerMainContainer from '../../../components/PartnerMainContainer';
import TitlePartner from '../component/Title';
import PartnerPageService from '../../../services/PartnerPageService';

const PartnerUsers = () => {
    useEffect(() => {
        PartnerPageService.loadUsers();
    }, []);
    
    return (
        <PartnerMainContainer>
            <TitlePartner title="Utilisateurs" sub="" icon="👥" />
        </PartnerMainContainer>
    );

}

export default PartnerUsers;
